import { apiAuth, apiResponseType } from "./index";
import { ServiceScriptFilters, ServiceScriptStoreData, ServiceScriptUpdateData } from "@/types/serviceScript";

export const getServiceScripts = (
  page = 1,
  params?: ServiceScriptFilters
): apiResponseType => {
  const queryParams = new URLSearchParams();
  queryParams.append("page", page.toString());

  if (params?.title) {
    queryParams.append("title", params.title);
  }
  if (params?.contest_id !== undefined && params?.contest_id !== null) {
    queryParams.append("contest_id", params.contest_id.toString());
  }
  if (params?.tag_id) {
    queryParams.append("tag_id", params.tag_id.toString());
  }
  if (params?.is_active !== undefined) {
    queryParams.append("is_active", params.is_active ? "1" : "0");
  }
  if (params?.date_from) {
    queryParams.append("date_from", params.date_from);
  }
  if (params?.date_to) {
    queryParams.append("date_to", params.date_to);
  }

  return apiAuth.get(`service-scripts?${queryParams.toString()}`);
};

export const getServiceScript = (uuid: string): apiResponseType =>
  apiAuth.get(`service-scripts/${uuid}/show`);

export const createServiceScript = (data: ServiceScriptStoreData): apiResponseType =>
  apiAuth.post("service-scripts/store", data);

export const updateServiceScript = (uuid: string, data: ServiceScriptUpdateData): apiResponseType =>
  apiAuth.put(`service-scripts/${uuid}/update`, data);

export const deleteServiceScript = (uuid: string): apiResponseType =>
  apiAuth.delete(`service-scripts/${uuid}/destroy`);

export const toggleServiceScriptStatus = (uuid: string): apiResponseType =>
  apiAuth.put(`service-scripts/${uuid}/toggle-status`);

export const storeServiceScriptAttachment = (
  uuid: string,
  formData: FormData
): apiResponseType =>
  apiAuth.post(`service-scripts/${uuid}/attachments`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const deleteServiceScriptAttachment = (
  uuid: string,
  attachmentId: number
): apiResponseType =>
  apiAuth.delete(`service-scripts/${uuid}/attachments/${attachmentId}`);

export const getServiceScriptTags = (name?: string): apiResponseType => {
  const queryParams = new URLSearchParams();
  if (name) {
    queryParams.append("name", name);
  }
  return apiAuth.get(`service-scripts/tags/select?${queryParams.toString()}`);
};
